import { render, staticRenderFns } from "./VehiculeDetail.vue?vue&type=template&id=301e52c6&"
import script from "./VehiculeDetail.vue?vue&type=script&lang=js&"
export * from "./VehiculeDetail.vue?vue&type=script&lang=js&"
import style0 from "./VehiculeDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports